import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <rect
      x={2}
      y={2}
      width={5.5}
      height={5.5}
      rx={2}
      fill={props.color || 'currentColor'}
    />
    <rect
      x={9}
      y={2}
      width={5.5}
      height={5.5}
      rx={2}
      fill={props.color || 'currentColor'}
    />
    <rect
      x={16}
      y={2}
      width={5.5}
      height={5.5}
      rx={2}
      fill={props.color || 'currentColor'}
    />
    <rect
      x={2}
      y={9}
      width={5.5}
      height={5.5}
      rx={2}
      fill={props.color || 'currentColor'}
    />
    <rect
      x={9}
      y={9}
      width={5.5}
      height={5.5}
      rx={2}
      fill={props.color || 'currentColor'}
    />
    <rect
      x={16}
      y={9}
      width={5.5}
      height={5.5}
      rx={2}
      fill={props.color || 'currentColor'}
    />
    <rect
      x={2}
      y={16}
      width={5.5}
      height={5.5}
      rx={2}
      fill={props.color || 'currentColor'}
    />
    <rect
      x={9}
      y={16}
      width={5.5}
      height={5.5}
      rx={2}
      fill={props.color || 'currentColor'}
    />
    <rect
      x={16}
      y={16}
      width={5.5}
      height={5.5}
      rx={2}
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgThumbnailsView = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgThumbnailsView;
